import * as actionType from "./ActionTypes";
import { findIndex, filter } from "lodash";
import moment from "moment";

export default function AddContainerReducers(state = {}, action) {
  const { payload } = action;
  switch (action.type) {
    case actionType.CONTAINER_DATA_LOAD:
      return (state = payload);
    case actionType.ADD_CONTAINER_DATA:
      var finalData = [...state];
      const findId = findIndex(state, (data) => {
        return (
          data.ContainerMasterId.toString() ===
          payload.ContainerMasterId.toString()
        );
      });
      for (let i = 0; i < state.length; i++) {
        if (
          state[i].ContainerMasterId.toString() ===
          payload.ContainerMasterId.toString()
        ) {
          finalData[findId] = {
            ...state[i],
            invoice: payload.containerValue.invoice,
            T_qty: payload.containerValue.T_qty,
            A_qty: payload.containerValue.A_qty,
            A_Part: payload.containerValue.A_Part,
            RFID_Seal_No: payload.containerValue.RFID_Seal_No,
            Product: payload.containerValue.Product,
            pick_up_location: payload.containerValue.pick_up_location,
            SAP_code: payload.containerValue.SAP_code,
            Remarks: payload.containerValue.Remarks,
            Gate_Out_Date: (payload.dateValue === "Invalid date" || payload.timeValue === "Invalid date") ? "" : moment(`${payload.dateValue}T${payload.timeValue}`).format("YYYY-MM-DD hh:mm A")
          };
        }
      }
      return finalData;
    case actionType.CONTAINER_DELETE_ROW:
      for (let i = 0; i < payload.deleteIdPayload.length; i++) {
        state = filter(state, function (datas) {
          return datas.ContainerMasterId !== parseInt(payload.deleteIdPayload[i]);
        });
      }
      // if(state.length === 0){
        payload.statePayload(state)
      // }
      return state;
    
    case actionType.CONTAINER_GATE_OUT:
      var finalGateOutPayload = [...state];
      const findIds = findIndex(state, (data) => {
        return (
          data.ContainerMasterId.toString() === payload.Id.toString()
        );
      });
      for (let i = 0; i < state.length; i++) {
        if (
          state[i].ContainerMasterId.toString() === payload.Id.toString()
        ) {
          finalGateOutPayload[findIds] = {
            ...state[i],
            Gate_Out_Date: payload.value,
            invoice:payload.invoicenumber
          };
        }
      }
      return finalGateOutPayload;
    case actionType.CONTAINER_UPDATE_BACK_TO_TOWN:
      for (let i = 0; i < state.length; i++) {
        if (
          state[i].ContainerMasterId.toString() === payload.Id.toString()
        ) {
          state[i].Back_To_Town = payload.value
        }
      }
      return state
    default:
      return state;
  }
}
